<template>
   <!-- 标签 -->
  <span class="workBench-classTag" :class="`workBench-classTag${status||''}`">{{getStatusName}}</span>
</template>
<script>
export default {
  props: ['status', 'projectType'],
  data () {
    return {
      statusName:''
    }
  },
  created () {

  },
  computed:{
    getStatusName(){
      let type=''
      switch(this.status){
        case "10":
            if (this.projectType =='20') {
              type = "公开询比价"
            } else {
              type = "公开招标"
            }
            break;
        case "20":
            if (this.projectType =='20') {
              type = "邀请询比价"
            } else {
              type = "邀请招标"
            }
            break;
        // case "117":
        //     type = "直接委托"
        //     break;
        // case "118":
        //     type = "询报价"
        //     break;
        // case "120":
        //     type = "单一来源"
        //     break;
        // case "121":
        //     type = "协议下单"
            break;
      }
      return type
    }
  },
  methods: {

  }
}
</script>
<style>
.workBench-classTag{
  position: relative;
  display: inline-block;
  background: #F5CA1D;
  padding-left:5px;
  padding-right: 5px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 18px;
  border-radius: 3px;
  border-radius: 3px;
}
.workBench-classTag10{
  background: #F5CA1D;
}
.workBench-classTag20{
  background: #65A0E6;
}
.workBench-classTag115{
  background: #F5CA1D;
}
.workBench-classTag116{
  background: #65A0E6;
}
.workBench-classTag117{
  background: #BD9EDD;
}
.workBench-classTag118{
  background: #D0AD9C;
}
.workBench-classTag120{
  background: #84CAB0;
}
.workBench-classTag121{
  background: #BD9EDD;
}

</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/classTag.vue